export enum FileLocationType {
  OTHER = -1,
  ARCHIVE = 1,
  LOCAL = 2
}